import { InjectionToken } from '@angular/core';

import { ISessionOptions } from '@relevance/core';

/**
 * Interface for the user API configuration.
 */
export interface UserServiceConfig {
  url: string;
  token?: string;
  options?: ISessionOptions;
}

/**
 * This injection token can be used to inject the user API configuration.
 */
export const USER_CONFIG = new InjectionToken<UserServiceConfig>('UserServiceConfig');
